import './assets/main.css'

import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import App from './App'
import { Toaster } from 'react-hot-toast'

// 环境检查
console.log('Ping Web 应用启动')
console.log('User Agent:', navigator.userAgent)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Toaster />
    <App />
  </StrictMode>
)
